/**
 * 全屏工作台布局：隐藏左侧栏，自带顶栏。
 *
 * 顶栏里的 Logo 下拉**镜像同一份 NAV_ITEMS**（竞品也是这个做法），
 * 目的是让人在深层工作台里也能一步跳回任意全局页，而不用先"退出"再导航。
 */
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { ChevronDown, PanelLeft } from 'lucide-react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';

import { useAppCapability } from '../capabilityContext';
import { NAV_ITEMS } from '../nav';

export function WorkbenchLayout({ title }: { title: string }) {
  const { preset } = useAppCapability();
  const location = useLocation();

  return (
    <div className="flex h-full flex-col">
      <header className="flex h-12 shrink-0 items-center gap-3 border-b border-surface-line bg-surface-raised px-3">
        <DropdownMenu.Root>
          <DropdownMenu.Trigger asChild>
            <button
              type="button"
              className="flex items-center gap-2 rounded-control px-2 py-1 hover:bg-surface-overlay"
            >
              <img src="/logo.png" alt="logo" className="h-[18px] w-[18px] rounded" />
              <span className="text-ui font-semibold">短剧创作 Pro</span>
              <ChevronDown size={14} className="text-ink-muted" />
            </button>
          </DropdownMenu.Trigger>
          <DropdownMenu.Portal>
            <DropdownMenu.Content
              align="start"
              sideOffset={6}
              className="z-50 min-w-[200px] rounded-card border border-surface-line
                         bg-surface-overlay p-1 shadow-xl"
            >
              {NAV_ITEMS.map((item) => (
                <DropdownMenu.Item asChild key={item.key}>
                  <NavLink
                    to={item.path}
                    end={item.path === '/'}
                    className="rounded-control px-3 py-1.5 text-ui text-ink-secondary
                               outline-none hover:bg-surface-raised hover:text-ink-primary"
                  >
                    {item.label}
                  </NavLink>
                </DropdownMenu.Item>
              ))}
            </DropdownMenu.Content>
          </DropdownMenu.Portal>
        </DropdownMenu.Root>

        <span className="text-ink-muted">/</span>
        <span className="text-ui">{title}</span>

        <div className="ml-auto flex items-center gap-3">
          {preset === null ? null : (
            <span className="text-uiSm text-ink-muted">画质 {preset.tier}</span>
          )}
          <NavLink
            to="/canvas"
            className="flex items-center gap-1.5 rounded-control border border-surface-line px-2.5 py-1
                       text-uiSm text-ink-secondary hover:bg-surface-overlay hover:text-ink-primary"
          >
            <PanelLeft size={14} />
            退出到画布
          </NavLink>
        </div>
      </header>

      <main className="min-h-0 flex-1 overflow-hidden" data-path={location.pathname}>
        <Outlet />
      </main>
    </div>
  );
}
